<template>
  <v-card class="mt-1 mb-1" elevation="1" >
    <v-card-title>{{ i }}</v-card-title>
    <v-card-text>
      <v-btn @click="printPDF" class="mb-2">Print</v-btn>
      <v-simple-table id="printSection">
        <tbody>
        <tr>
          <td>
            <v-simple-table>
        <thead>
        <tr>
          <th class="text-left">
            Question
          </th>
          <th class="text-left">
            Results
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data,k) in wardSummary">
          <td>{{ wardSummary[k][0].question }}</td>
          <td>
            <v-simple-table>
        <thead>
        <th>Candidate</th>
        <th>Votes</th>
        <th>Percentage</th>
        </thead>
        <tbody>
        <tr v-for="(item,j) in data">
          <td>{{ item.name }}</td>
          <td>{{ item.votes}}</td>
<!--          <td>{{ data }}</td>-->
          <td>{{ ((item.votes/data.map(bill => bill.votes).reduce((acc, bill) => bill + acc) ) * 100).toFixed(0) + '%'}}</td>
        </tr>
        </tbody>
      </v-simple-table>
      </td>
      </tr>
      </tbody>
      </v-simple-table>
      </td>
      </tr>
      </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PollTable",
  props: {
    i: {
      type: String,
      required: true
    },
    wardSummary: {
      required: true
    }
  },
  methods:{
    printPDF: function () {
      const prtHtml = document.getElementById('printSection').innerHTML;

// Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

// Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
                        <html>
                          <head>
                            ${stylesHtml}
                          </head>
                          <body>
                            ${prtHtml}
                          </body>
                        </html>`);

      // WinPrint.document.close();
      // WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
  }
}
</script>

<style scoped>

</style>